import React, { Component } from 'react'
import { Select } from 'hljd'
import Api from '@api/team'
import isEmpty from 'lodash/isEmpty'
import { isSiYiTeam } from '@util'
const Option = Select.Option

export default class extends Component {
  static defaultProps = {
    params: {},
    placeholder: '成员'
  }

  constructor(props) {
    super(props)

    this.state = {
      list: []
    }
  }

  async componentDidMount() {
    const { needSelf } = this.props
    const params = { ...this.props.params }
    if (needSelf) {
      params.needSelf = 1
    }
    const MenberApi = isSiYiTeam() ? 'getMemberList' : 'mainGroupMemberList'
    const { success, data } = await Api[MenberApi](
      isSiYiTeam() ? { orderPageListAll: true } : params
    )
    if (success) {
      console.log(data)
      const _data = isEmpty(isSiYiTeam() ? data.list : data)
        ? []
        : isSiYiTeam()
          ? data.list
          : data
      this.setState({ list: _data })
      const { onDataLoaded } = this.props
      onDataLoaded && onDataLoaded(_data)
    }
  }

  render() {
    return (
      <Select {...this.props}>
        <Option value="">全部</Option>
        {this.state.list.map(({ id, name }) => {
          return (
            <Option key={id} value={id}>
              {name}
            </Option>
          )
        })}
      </Select>
    )
  }
}
